import { render, staticRenderFns } from "./UserOnboardView.vue?vue&type=template&id=0d09e49f&scoped=true"
import script from "./UserOnboardView.vue?vue&type=script&lang=js"
export * from "./UserOnboardView.vue?vue&type=script&lang=js"
import style0 from "./UserOnboardView.vue?vue&type=style&index=0&id=0d09e49f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d09e49f",
  null
  
)

export default component.exports